<mat-card class="crear-resumen-dialog">
  <app-card-header
    title="Crear resumen del mes"
    [draggable]="true"
  ></app-card-header>
  <mat-divider></mat-divider>

  @if (form && !loading) {
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <mat-card-content class="crear-resumen-content">
        <p class="crear-resumen-ayuda">
          Genera el resumen de facturación del cliente elegido para el mes
          seleccionado. Si ya existe, se omite.
        </p>

        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Cliente</mat-label>
          <mat-select formControlName="idCliente">
            @for (c of clientesFacturables; track c.idCliente) {
              <mat-option [value]="c.idCliente">{{ c.nombre }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Año</mat-label>
          <mat-select formControlName="anio" (selectionChange)="onAnioChange()">
            @for (a of anios; track a) {
              <mat-option [value]="a">{{ a }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%">
          <mat-label>Mes</mat-label>
          <mat-select formControlName="mes">
            @for (m of mesesDisponibles; track m.valor) {
              <mat-option [value]="m.valor">{{ m.nombre }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-card-content>

      <mat-divider></mat-divider>
      <mat-card-actions align="end">
        <button irxBoton="texto" type="button" (click)="dialogRef.close()">
          Cancelar
        </button>
        <button irxBoton="principal" type="submit">Generar</button>
      </mat-card-actions>
    </form>
  } @else {
    <div class="crear-resumen-loading">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }
</mat-card>
